import { createApi } from "@reduxjs/toolkit/query/react";
import { DeployListPreset, GetDeployListPreset } from "@shared/models";
import { axiosBaseQuery } from "@shared/utils/request";

import config from "../../../config";

export const presetApi = createApi({
  reducerPath: "presetApi",
  baseQuery: axiosBaseQuery({
    baseUrl: `${config.baseApiUrl}presets`,
  }),
  tagTypes: ["Presets"],
  endpoints: (builder) => ({
    getPresets: builder.query<DeployListPreset[], GetDeployListPreset>({
      providesTags: ["Presets"],
      query: (params) => ({ url: "", params }),
      keepUnusedDataFor: 0, // clear cache, make request every time (for "create deploy list modal")
    }),
  }),
});

export const { useGetPresetsQuery } = presetApi;
